<template>
  <div class="static-page page">
    <div class="static-page__container">
      <h1 class="static-page__title">{{ page.title }}</h1>
      <div v-if="page.description" class="static-page__description">
        <EditorJSComponent :text="staticPageContent" />
      </div>
    </div>
  </div>
</template>

<script>
import PAGE from "@/graphql/queries/page.graphql";
import EditorJSComponent from "components/EditorJSComponent.vue";

function resolveStaticLink(route) {
  return (route.meta && route.meta.staticLink) || route.params.link;
}

export default {
  name: "StaticPage",
  async asyncData({ apollo, store, route }) {
    await apollo.defaultClient
      .query({
        query: PAGE,
        variables: {
          link: resolveStaticLink(route),
        },
      })
      .then(({ data }) => {
        store.state.static_page = data.page;
        store.state.categories = data.categories;
        if (data.exchange_rates) store.state.exchange_rates = data.exchange_rates;
      });
  },
  computed: {
    staticPageContent() {
      const content = JSON.parse(this.page.description);

      if (
        !content ||
        !Array.isArray(content.blocks) ||
        content.blocks.length === 0
      ) {
        return content;
      }

      const first = content.blocks[0];

      if (!first || first.type !== "header" || !first.data) {
        return content;
      }

      const normalize = (value) =>
        String(value || "")
          .replace(/<[^>]*>/g, "")
          .replace(/\s+/g, " ")
          .trim()
          .toLowerCase();

      if (
        !this.page.title ||
        normalize(first.data.text) !== normalize(this.page.title)
      ) {
        return content;
      }

      return {
        ...content,
        blocks: content.blocks.slice(1),
      };
    },

    page() {
      return this.$store.state.static_page || {};
    },
    metaTitle() {
      return this.$store.state.pages.find((page) => page.link === resolveStaticLink(this.$route))?.meta_title;
    },
    metaDescription() {
      return this.$store.state.pages.find((page) => page.link === resolveStaticLink(this.$route))?.meta_description;
    },
    metaKeywords() {
      return this.$store.state.pages.find((page) => page.link === resolveStaticLink(this.$route))?.meta_keywords;
    },
  },
  components: {
    EditorJSComponent,
  },
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        {
          vmid: "keywords",
          name: "keywords",
          content: this.metaKeywords,
        },
        {
          vmid: "description",
          name: "description",
          content: this.metaDescription,
        },
        {
          vmid: "og:title",
          name: "og:title",
          content: this.metaTitle,
        },
        {
          vmid: "og:description",
          name: "og:description",
          content: this.metaDescription,
        },
      ],
    };
  },
};
</script>

<style lang="stylus">
.static-page {
  display grid
  padding 32px 15px 48px
  +below(860px) {
    padding 15px
  }

  &__container {
		max-width: var(--main_width)
		width: 100%
    display grid
    align-items start
    gap 24px
    margin 0 auto
  }

  &__title {
    margin 0
  }
}
</style>
